import EAIcon from 'components/common/EAIcon';
import React from 'react';
import useStyles from 'style/js-style/components/AdditionalMessageAlertStyle';

const AdditionalMessageAlert = ({ icon, message }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <EAIcon icon={icon} className={classes.icon} width={20}/>
      <div className={classes.message}>{message}</div>
    </div>
  );
};

export default AdditionalMessageAlert;
